// axios
import axios from 'axios'

const domain = "https://mynex.ru"

export default axios.create({
  domain
  // You can add your headers here
})
